import { GzThreatsBreakdownWebComponent } from './component/ThreatsBreakdownWebComponent';

export { GzThreatsBreakdownWebComponent };
